import { ConnectorConfigMapping } from "@pufflig/prompt-studio-types";

export enum Limitation {
  PORT,
  URL,
}

export interface FormRow {
  label: string;
  id: string;
  type?: "textarea" | "password" | "number";
  placeholder: string;
  isRequired: boolean;
  limitation?: Limitation;
}

export type FormRowArray<T extends { type: string }> = Array<
  FormRow & { id: keyof Omit<T, "type"> | "name" | "description" }
>;

export type ConnectorFormConfig = {
  [K in keyof ConnectorConfigMapping]: FormRowArray<ConnectorConfigMapping[K]>;
};
